// extracted by mini-css-extract-plugin
module.exports = {"fileFormatCol":"ReportsTableWidget_fileFormatCol__2XaDM","fileFormat":"ReportsTableWidget_fileFormat__xIMsi","fileFormatSpinner":"ReportsTableWidget_fileFormatSpinner__2B7GS"};